// Module
var code = `<div class="modal-dialog io-stats-widget-settings" role="document">
    <div class="modal-content" tabindex="-1">
        <div class="modal-header">
            <div class="flex-horizontal">
                <div class="flex-grow">
                    <h3>IO Stats Widget Settings</h3>
                </div>
                <div>
                    <button type="button" class="close" data-bind="click: close" aria-hidden="true">
                        <i class="icon-cancel"></i>
                    </button>
                </div>
            </div>
        </div>
        <div class="modal-body">
            <div class="flex-form">
                <div>
                    Show separate read &amp; write graphs for:
                </div>
                <div class="form-group">
                    <label class="control-label">&nbsp;</label>
                    <div class="toggle">
                        <input id="splitIops" type="checkbox" data-bind="checked: splitIops">
                        <label for="splitIops">IOPS</label>
                    </div>
                </div>
                <div class="form-group">
                    <label class="control-label">&nbsp;</label>
                    <div class="toggle">
                        <input id="splitThroughput" type="checkbox" data-bind="checked: splitThroughput">
                        <label for="splitThroughput">Throughput</label>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal-footer">
            <div class="text-right">
                <button type="button" class="btn btn-default" data-bind="click: close"><i class="icon-cancel"></i><span>Cancel</span></button>
                <button data-bind="click: saveSettings" type="button" class="btn btn-primary">
                    <i class="icon-save"></i><span>Save</span>
                </button>
            </div>
        </div>
    </div>
</div>
`;
// Exports
export default code;